import React, { useState } from 'react';
import Cookies from 'js-cookie';

const setCookie = () => {
  Cookies.set('cookie.policy', '1', {
    expires: 365,
    sameSite: 'strict',
    secure: window.location.protocol === 'https:',
  });
};

const CookiePolicy = () => {
  const [read, setRead] = useState(
    Cookies.get('cookie.policy') === '1',
  );

  if (read) return '';

  return (
    <div
      className="fixed-bottom w-100 container-fluid"
    >
      <div className="row">
        <div className="col py-3 bg-tertiary text-white">
          This website uses cookies to ensure you get the best experience on our website.
          <a
            className="text-white mx-2 text-nowrap"
            href="https://www.cookiesandyou.com/"
          >
            <u>Learn more</u>
          </a>
        </div>
        <a
          className="col-auto d-flex px-4 py-3 bg-quaternary"
          onClick={() => {
            setCookie();
            setRead(true);
          }}
        >
          <div className="my-auto">
            Got it!
          </div>
        </a>
      </div>
    </div>
  );
};

export default CookiePolicy;
